import { render, staticRenderFns } from "./NotaCreditoBoletaConsulta.vue?vue&type=template&id=c18da3b4&"
import script from "./NotaCreditoBoletaConsulta.vue?vue&type=script&lang=js&"
export * from "./NotaCreditoBoletaConsulta.vue?vue&type=script&lang=js&"
import style0 from "./NotaCreditoBoletaConsulta.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports